module.exports = __webpack_public_path__ + "public/img/Mengolah Data Penjualan dengan Microsoft Excel untuk Menjadi Admin Input Data.b9ec6bfc.png";